(function () {
  'use strict';

  var SPECIAL_MODELS = [
    'Ford F-150', 'Ford F-250', 'Ford F-350',
    'Chevrolet Silverado 1500', 'Chevrolet Silverado 2500',
    'Dodge RAM 1500', 'Dodge RAM 2500', 'Toyota Tundra'
  ];

  var CAB_RULES = {
    'VW Amarok':        ['Dual Cab', 'Extra Cab'],
    'Toyota LC79':      ['Dual Cab', 'Single Cab'],
    'Jeep Gladiator':   ['Dual Cab'],
    'LDV T60':          ['Dual Cab'],
    'GWM Cannon':       ['Dual Cab', 'Extra Cab'],
    'GWM Cannon Alpha': ['Dual Cab'],
    'SsangYong Musso':  ['Dual Cab'],
    'BYD Shark':        ['Dual Cab'],
    'Kia Tasman':       ['Dual Cab', 'Single Cab']
  };

  var PKG_RULES = {
    'trade-01':  { rearAcc: 'none',    roofPlatformMin: 1800 },
    'touring-01':{ rearAcc: 'touring', roofPlatformMin: null },
    'flex-01':   { rearAcc: 'flex',    roofPlatformMin: null },
    'flex-02':   { rearAcc: 'flex',    roofPlatformMin: null }
  };

  var PKG_NAMES = {
    'trade-01':  'Trade Package 01',
    'touring-01':'Touring Package 01',
    'flex-01':   'Flex Package 01',
    'flex-02':   'Flex Package 02'
  };

  var TRAY_LENGTH = 1850;
  var DRAWER_OPTIONS = [900, 1200, 1400, 1700];
  var ALL_PLATFORM_OPTIONS = [1600, 1800, 2100, 2400, 2700, 3000];

  var ACC_LIMITS_TOURING = { ladder: 1, tyre: 2, jerry: 2 };
  var ACC_LIMITS_FLEX = { 'tyre-flex': 1, 'jerry-flex': 1 };
  var MAX_TOURING_TOTAL = 3;
  var MAX_FLEX_TOTAL = 2;

  var WORKER_URL = 'https://cdi-pkg-worker.coredrivenindustries.workers.dev';

  function pushEvent(eventName, params) {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish('cdi:' + eventName, params);
    }
  }

  var wizard = {
    el: null,
    steps: [],
    currentStep: 1,
    totalSteps: 5,
    currentPkg: '',
    touringAcc: { ladder: 0, tyre: 0, jerry: 0 },
    flexAcc: { tyre: 0, jerry: 0 },
    _isSubmitting: false,
    _leadSent: false,

    init: function () {
      this.el = document.getElementById('cdi-pkg-cust');
      if (!this.el) return;
      this.steps = Array.from(this.el.querySelectorAll('.cdi-pkg-cust__step'));

      this._bindPkgCards();
      this._bindStep2();
      this._bindStep3();
      this._bindStep4();
      this._bindStep5();
      this._bindNav();
      this._bindEscape();

      var panel = document.getElementById('cdi-pkg-customise-panel');
      if (panel) {
        panel.addEventListener('cdi-pkg:flow-activated', function (e) {
          wizard._onFlowActivated(e.detail ? e.detail.params : {});
        });
      }
    },

    _onFlowActivated: function (params) {
      var pkg = params.package || '';
      if (pkg && PKG_NAMES[pkg]) {
        var radio = this.el.querySelector('input[name="package_handle"][value="' + pkg + '"]');
        if (radio) {
          radio.checked = true;
          radio.closest('.cdi-pkg-cust__pkg-card').classList.add('is-selected');
          this.currentPkg = pkg;
          document.getElementById('cdi-pkgc-pkg-name').value = PKG_NAMES[pkg];
          this._validateStep(1);
        }
      }
      var modelSel = document.getElementById('cdi-pkgc-model');
      if (params.model && modelSel) {
        for (var i = 0; i < modelSel.options.length; i++) {
          if (modelSel.options[i].value === params.model) {
            modelSel.value = params.model;
            var sx = document.getElementById('cdi-pkgc-model-selectx');
            if (sx && sx._syncValue) sx._syncValue();
            this._onModelChange();
            break;
          }
        }
      }
      var yearIn = document.getElementById('cdi-pkgc-year');
      if (params.year && yearIn) {
        yearIn.value = params.year;
        this._validateStep(2);
      }
      var finishSel = document.getElementById('cdi-pkgc-finish');
      if (params.finish && finishSel) {
        var finishWords = params.finish.toLowerCase().split(/\s+/).filter(Boolean);
        for (var j = 0; j < finishSel.options.length; j++) {
          var optionText = finishSel.options[j].value.toLowerCase();
          var matches = optionText && finishWords.every(function (w) { return optionText.indexOf(w) !== -1; });
          if (matches) {
            finishSel.value = finishSel.options[j].value;
            var fx = document.getElementById('cdi-pkgc-finish-selectx');
            if (fx && fx._syncValue) fx._syncValue();
            this._onFinishChange();
            break;
          }
        }
      }
      if (pkg && PKG_NAMES[pkg]) {
        this._goToStep(2);
      }
    },

    _bindPkgCards: function () {
      var self = this;
      var radios = this.el.querySelectorAll('.cdi-pkg-cust__pkg-radio');
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          self.el.querySelectorAll('.cdi-pkg-cust__pkg-card').forEach(function (c) {
            c.classList.remove('is-selected');
          });
          radio.closest('.cdi-pkg-cust__pkg-card').classList.add('is-selected');
          self.currentPkg = radio.value;
          document.getElementById('cdi-pkgc-pkg-name').value = PKG_NAMES[radio.value] || radio.value;
          self._validateStep(1);
        });
      });
    },

    _bindStep2: function () {
      var self = this;
      var modelSel  = document.getElementById('cdi-pkgc-model');
      var yearIn    = document.getElementById('cdi-pkgc-year');
      var cabSel    = document.getElementById('cdi-pkgc-cab');
      var finishSel = document.getElementById('cdi-pkgc-finish');
      var colourIn  = document.getElementById('cdi-pkgc-colour-code');
      if (modelSel)  modelSel.addEventListener('change', function () { self._onModelChange(); });
      if (yearIn)    yearIn.addEventListener('input', function () { self._validateStep(2); });
      if (cabSel)    cabSel.addEventListener('change', function () { self._validateStep(2); });
      if (finishSel) finishSel.addEventListener('change', function () { self._onFinishChange(); });
      if (colourIn)  colourIn.addEventListener('input', function () { self._validateStep(2); });
    },

    _onModelChange: function () {
      var modelSel   = document.getElementById('cdi-pkgc-model');
      var otherField = document.getElementById('cdi-pkgc-other-model-field');
      var otherIn    = document.getElementById('cdi-pkgc-other-model');
      var specField  = document.getElementById('cdi-pkgc-spec-field');
      var specIn     = document.getElementById('cdi-pkgc-spec');
      var model      = modelSel ? modelSel.value : '';

      if (otherField && otherIn) {
        var showOther = model === 'Other';
        otherField.classList.toggle('is-hidden', !showOther);
        otherIn.required = showOther;
        if (!showOther) otherIn.value = '';
      }
      if (specField && specIn) {
        var showSpec = model !== '' && model !== 'Other';
        specField.classList.toggle('is-hidden', !showSpec);
        if (!showSpec) specIn.value = '';
      }

      var cabSel = document.getElementById('cdi-pkgc-cab');
      if (!cabSel) return;
      var allowed;
      if (SPECIAL_MODELS.indexOf(model) !== -1) {
        allowed = ['Dual Cab'];
      } else if (CAB_RULES[model]) {
        allowed = CAB_RULES[model];
      } else {
        allowed = ['Dual Cab', 'Extra Cab', 'Single Cab'];
      }
      cabSel.innerHTML = '<option value="">Select cab type</option>';
      allowed.forEach(function (c) { cabSel.appendChild(new Option(c, c)); });
      var cabSx = document.getElementById('cdi-pkgc-cab-selectx');
      if (cabSx && cabSx._renderOptions) { cabSx._renderOptions(); cabSx._syncValue(); }

      this._validateStep(2);
    },

    _onFinishChange: function () {
      var finishSel   = document.getElementById('cdi-pkgc-finish');
      var colourField = document.getElementById('cdi-pkgc-colour-code-field');
      var colourIn    = document.getElementById('cdi-pkgc-colour-code');
      if (!finishSel || !colourField || !colourIn) return;
      var needsCode = finishSel.value === 'Black body with colour-matched doors';
      colourField.classList.toggle('is-hidden', !needsCode);
      colourIn.required = needsCode;
      if (!needsCode) colourIn.value = '';
      this._validateStep(2);
    },

    _bindStep3: function () {
      var self = this;
      this.el.querySelectorAll('.cdi-pkg-cust__stepper-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self._stepAcc(btn.dataset.acc, parseInt(btn.dataset.dir));
        });
      });
    },

    _setupStep3: function () {
      var pkg   = this.currentPkg;
      var rules = PKG_RULES[pkg] || {};

      var label = document.getElementById('cdi-pkgc-addons-pkg-label');
      if (label) label.textContent = PKG_NAMES[pkg] ? 'Configuring: ' + PKG_NAMES[pkg] : '';

      var touringField = document.getElementById('cdi-pkgc-rear-acc-fieldset');
      var flexField    = document.getElementById('cdi-pkgc-flex-acc-fieldset');
      if (touringField) touringField.classList.toggle('is-hidden', rules.rearAcc !== 'touring');
      if (flexField)    flexField.classList.toggle('is-hidden',    rules.rearAcc !== 'flex');

      this._updateRoofRackOptions(rules.roofPlatformMin);

      this._updateDrawerOptions();
      this.touringAcc = { ladder: 0, tyre: 0, jerry: 0 };
      this.flexAcc = { tyre: 0, jerry: 0 };
      this._syncAccDisplay();
    },

    _updateDrawerOptions: function () {
      var drawerSel = document.getElementById('cdi-pkgc-drawer');
      if (!drawerSel) return;
      var current = drawerSel.value;
      drawerSel.innerHTML = '<option value="None">No trundle drawer</option>';
      DRAWER_OPTIONS.forEach(function (d) {
        drawerSel.appendChild(new Option(d + ' mm', d));
      });
      if (drawerSel.querySelector('option[value="' + current + '"]')) {
        drawerSel.value = current;
      } else {
        drawerSel.value = 'None';
      }
      var sx = document.getElementById('cdi-pkgc-drawer-selectx');
      if (sx && sx._renderOptions) { sx._renderOptions(); sx._syncValue(); }
    },

    _updateRoofRackOptions: function (platformMin) {
      var rackSel = document.getElementById('cdi-pkgc-roof-rack');
      if (!rackSel) return;
      var current = rackSel.value;
      rackSel.innerHTML = '<option value="None">No roof rack</option>';
      rackSel.appendChild(new Option('2 bars', '2 bars'));
      rackSel.appendChild(new Option('3 bars', '3 bars'));
      ALL_PLATFORM_OPTIONS.forEach(function (p) {
        if (!platformMin || p >= platformMin) {
          rackSel.appendChild(new Option('Platform ' + p + ' mm', 'Platform ' + p));
        }
      });
      if (rackSel.querySelector('option[value="' + current + '"]')) {
        rackSel.value = current;
      } else {
        rackSel.value = 'None';
      }
      var sx = document.getElementById('cdi-pkgc-roof-rack-selectx');
      if (sx && sx._renderOptions) { sx._renderOptions(); sx._syncValue(); }
    },

    _stepAcc: function (acc, dir) {
      var rules = PKG_RULES[this.currentPkg] || {};

      if (acc === 'jerry-flex' || acc === 'tyre-flex') {
        var flexKey = acc === 'jerry-flex' ? 'jerry' : 'tyre';
        var flexTotal = this.flexAcc.tyre + this.flexAcc.jerry;
        var flexLimit = ACC_LIMITS_FLEX[acc] || 2;
        var flexCurrent = this.flexAcc[flexKey];
        var newValF = flexCurrent + dir;
        if (newValF < 0 || newValF > flexLimit) return;
        if (dir > 0 && flexTotal >= MAX_FLEX_TOTAL) return;
        this.flexAcc[flexKey] = newValF;
        var elF = this.el.querySelector('.cdi-pkg-cust__stepper-val[data-acc="' + acc + '"]');
        if (elF) elF.textContent = newValF;
        var hiddenFlexMap = { 'jerry-flex': 'cdi-pkgc-acc-jerry-flex', 'tyre-flex': 'cdi-pkgc-acc-tyre-flex' };
        var hiddenF = document.getElementById(hiddenFlexMap[acc]);
        if (hiddenF) hiddenF.value = newValF;
      } else {
        var current = this.touringAcc[acc] || 0;
        var limit   = ACC_LIMITS_TOURING[acc] || 1;
        var total   = this.touringAcc.ladder + this.touringAcc.tyre + this.touringAcc.jerry;
        var newValT = current + dir;
        if (newValT < 0 || newValT > limit) return;
        if (dir > 0 && total >= MAX_TOURING_TOTAL) return;
        this.touringAcc[acc] = newValT;
        var elT = this.el.querySelector('.cdi-pkg-cust__stepper-val[data-acc="' + acc + '"]');
        if (elT) elT.textContent = newValT;
        var hiddenMap = { ladder: 'cdi-pkgc-acc-ladder', tyre: 'cdi-pkgc-acc-tyre', jerry: 'cdi-pkgc-acc-jerry-touring' };
        var hiddenIn = document.getElementById(hiddenMap[acc]);
        if (hiddenIn) hiddenIn.value = newValT;
      }
      this._refreshStepperButtons();
    },

    _syncAccDisplay: function () {
      var self = this;
      ['ladder', 'tyre', 'jerry'].forEach(function (acc) {
        var el = self.el.querySelector('.cdi-pkg-cust__stepper-val[data-acc="' + acc + '"]');
        if (el) el.textContent = 0;
        var hiddenMap = { ladder: 'cdi-pkgc-acc-ladder', tyre: 'cdi-pkgc-acc-tyre', jerry: 'cdi-pkgc-acc-jerry-touring' };
        var h = document.getElementById(hiddenMap[acc]);
        if (h) h.value = 0;
      });
      var jfEl = this.el.querySelector('.cdi-pkg-cust__stepper-val[data-acc="jerry-flex"]');
      if (jfEl) jfEl.textContent = 0;
      var jfH = document.getElementById('cdi-pkgc-acc-jerry-flex');
      if (jfH) jfH.value = 0;
      var tfEl = this.el.querySelector('.cdi-pkg-cust__stepper-val[data-acc="tyre-flex"]');
      if (tfEl) tfEl.textContent = 0;
      var tfH = document.getElementById('cdi-pkgc-acc-tyre-flex');
      if (tfH) tfH.value = 0;
      this.flexAcc = { tyre: 0, jerry: 0 };
      this._refreshStepperButtons();
    },

    _refreshStepperButtons: function () {
      var self  = this;
      var total = this.touringAcc.ladder + this.touringAcc.tyre + this.touringAcc.jerry;

      ['ladder', 'tyre', 'jerry'].forEach(function (acc) {
        var current = self.touringAcc[acc];
        var limit   = ACC_LIMITS_TOURING[acc];
        var plus  = self.el.querySelector('.cdi-pkg-cust__stepper-btn[data-acc="' + acc + '"][data-dir="1"]');
        var minus = self.el.querySelector('.cdi-pkg-cust__stepper-btn[data-acc="' + acc + '"][data-dir="-1"]');
        if (plus)  plus.disabled  = current >= limit || total >= MAX_TOURING_TOTAL;
        if (minus) minus.disabled = current <= 0;
      });

      var flexTotal = this.flexAcc.tyre + this.flexAcc.jerry;
      ['jerry-flex', 'tyre-flex'].forEach(function (acc) {
        var flexKey = acc === 'jerry-flex' ? 'jerry' : 'tyre';
        var flexCurrent = self.flexAcc[flexKey];
        var flexLimit = ACC_LIMITS_FLEX[acc] || 2;
        var fPlus  = self.el.querySelector('.cdi-pkg-cust__stepper-btn[data-acc="' + acc + '"][data-dir="1"]');
        var fMinus = self.el.querySelector('.cdi-pkg-cust__stepper-btn[data-acc="' + acc + '"][data-dir="-1"]');
        if (fPlus)  fPlus.disabled  = flexCurrent >= flexLimit || flexTotal >= MAX_FLEX_TOTAL;
        if (fMinus) fMinus.disabled = flexCurrent <= 0;
      });
    },

    _bindStep4: function () {
      var self     = this;
      var radios   = this.el.querySelectorAll('input[name="installation"]');
      var listField= document.getElementById('cdi-pkgc-install-checklist-field');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (listField) listField.classList.toggle('is-hidden', r.value !== 'Yes');
          self._validateStep(4);
        });
      });
    },

    _bindStep5: function () {
      var self  = this;
      var nameIn  = document.getElementById('cdi-pkgc-name');
      var emailIn = document.getElementById('cdi-pkgc-email');
      if (nameIn)  nameIn.addEventListener('input', function () { self._validateStep(5); });
      if (emailIn) emailIn.addEventListener('input', function () { self._validateStep(5); });
      var submitBtn = document.getElementById('cdi-pkgc-submit-btn');
      if (submitBtn) {
        submitBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self._submitForm();
        });
      }
    },

    _bindEscape: function () {
      var btn = document.getElementById('cdi-pkgc-switch-scratch');
      if (btn) {
        btn.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('cdi-pkg:switch-to-scratch'));
        });
      }
    },

    _validateStep: function (n) {
      if (n === 1) {
        var nextBtn = this.el.querySelector('.cdi-pkg-cust__step[data-step="1"] .cdi-pkg-cust__btn--next');
        if (nextBtn) nextBtn.disabled = !this.currentPkg;

      } else if (n === 2) {
        var nextBtn2 = this.el.querySelector('.cdi-pkg-cust__step[data-step="2"] .cdi-pkg-cust__btn--next');
        var model  = (document.getElementById('cdi-pkgc-model') || {}).value || '';
        var year   = ((document.getElementById('cdi-pkgc-year') || {}).value || '').trim();
        var cab    = (document.getElementById('cdi-pkgc-cab') || {}).value || '';
        var finish = (document.getElementById('cdi-pkgc-finish') || {}).value || '';
        var colour = ((document.getElementById('cdi-pkgc-colour-code') || {}).value || '').trim();
        var other  = ((document.getElementById('cdi-pkgc-other-model') || {}).value || '').trim();
        var valid  = model && year.length >= 4 && cab && finish;
        if (finish === 'Black body with colour-matched doors' && !colour) valid = false;
        if (model === 'Other' && !other) valid = false;
        if (nextBtn2) nextBtn2.disabled = !valid;

      } else if (n === 4) {
        var nextBtn4 = this.el.querySelector('.cdi-pkg-cust__step[data-step="4"] .cdi-pkg-cust__btn--next');
        var install  = this.el.querySelector('input[name="installation"]:checked');
        if (nextBtn4) nextBtn4.disabled = !install;

      } else if (n === 5) {
        var submitBtn = document.getElementById('cdi-pkgc-submit-btn');
        var name  = ((document.getElementById('cdi-pkgc-name') || {}).value || '').trim();
        var email = ((document.getElementById('cdi-pkgc-email') || {}).value || '').trim();
        var ok    = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (submitBtn) submitBtn.disabled = !(name && ok);
      }
    },

    _bindNav: function () {
      var self = this;
      this.el.querySelectorAll('.cdi-pkg-cust__btn--next').forEach(function (btn) {
        btn.addEventListener('click', function () { self._goToStep(parseInt(btn.dataset.next)); });
      });
      this.el.querySelectorAll('.cdi-pkg-cust__btn--back').forEach(function (btn) {
        btn.addEventListener('click', function () { self._goToStep(parseInt(btn.dataset.back)); });
      });
    },

    _goToStep: function (n) {
      if (n < 1 || n > this.totalSteps) return;
      this.steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i + 1 === n);
      });
      var STEP_NAMES = ['Package', 'Vehicle', 'Add-ons', 'Installation', 'Your info'];
      var fillPct  = ((n - 1) / (this.totalSteps - 1) * 100).toFixed(1);
      var countEl  = document.getElementById('cdi-pkgc-progress-count');
      var nameEl   = document.getElementById('cdi-pkgc-progress-name');
      var fillEl   = document.getElementById('cdi-pkgc-progress-fill');
      var trackEl  = fillEl && fillEl.closest('[role="progressbar"]');
      if (countEl) countEl.textContent = 'Step ' + n + ' of ' + this.totalSteps;
      if (nameEl)  nameEl.textContent  = STEP_NAMES[n - 1] || '';
      if (fillEl)  fillEl.style.width  = fillPct + '%';
      if (trackEl) trackEl.setAttribute('aria-valuenow', n);
      this.currentStep = n;
      if (n === 3) this._setupStep3();
      if (n === 5) this._validateStep(5);
      var progressBar = this.el.querySelector('.cdi-pkg-cust__progress');
      if (progressBar) progressBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var newStep = this.el.querySelector('.cdi-pkg-cust__step[data-step="' + n + '"]');
      if (newStep) {
        var title = newStep.querySelector('.cdi-pkg-cust__step-title');
        if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
      }
    },

    _submitForm: function () {
      var phoneEl = document.getElementById('cdi-pkgc-phone');
      if (phoneEl && !phoneEl.value.trim()) {
        phoneEl.focus();
        phoneEl.reportValidity();
        return;
      }
      if (this._isSubmitting) return;
      this._isSubmitting = true;

      var self      = this;
      var submitBtn = document.getElementById('cdi-pkgc-submit-btn');
      var successEl = document.getElementById('cdi-pkgc-feedback-success');
      var errorEl   = document.getElementById('cdi-pkgc-feedback-error');

      var installChecks = Array.from(
        this.el.querySelectorAll('input[name="install_includes[]"]:checked')
      ).map(function (cb) { return cb.value; });

      var roofRack = (document.getElementById('cdi-pkgc-roof-rack') || {}).value || 'None';
      var roofRackBars     = null;
      var roofRackPlatform = null;
      if (roofRack === '2 bars') { roofRackBars = 2; }
      else if (roofRack === '3 bars') { roofRackBars = 3; }
      else if (roofRack.indexOf('Platform') === 0) {
        roofRackPlatform = roofRack.replace('Platform ', '');
      }

      var rules = PKG_RULES[this.currentPkg] || {};
      var accJerry = 0;
      var accTyre  = 0;
      if (rules.rearAcc === 'touring') {
        accJerry = this.touringAcc.jerry;
        accTyre  = this.touringAcc.tyre;
      } else if (rules.rearAcc === 'flex') {
        accJerry = this.flexAcc.jerry;
        accTyre  = this.flexAcc.tyre;
      }

      var payload = {
        enquiry_type:    'customise',
        package_handle:  this.currentPkg,
        package_name:    PKG_NAMES[this.currentPkg] || '',
        vehicle_model:   (document.getElementById('cdi-pkgc-model') || {}).value || '',
        vehicle_model_other: (document.getElementById('cdi-pkgc-other-model') || {}).value || '',
        vehicle_spec:    (document.getElementById('cdi-pkgc-spec') || {}).value || '',
        vehicle_year:    (document.getElementById('cdi-pkgc-year') || {}).value || '',
        cab_type:        (document.getElementById('cdi-pkgc-cab') || {}).value || '',
        finish:          (document.getElementById('cdi-pkgc-finish') || {}).value || '',
        colour_code:     (document.getElementById('cdi-pkgc-colour-code') || {}).value || '',
        trundle_drawer:  (document.getElementById('cdi-pkgc-drawer') || {}).value || 'None',
        roof_rack_bars:       roofRackBars,
        roof_rack_platform:   roofRackPlatform,
        acc_ladder:  rules.rearAcc === 'touring' ? this.touringAcc.ladder : 0,
        acc_tyre:    accTyre,
        acc_jerry:   accJerry,
        installation:    ((this.el.querySelector('input[name="installation"]:checked') || {}).value) || '',
        install_includes: installChecks,
        name:    (document.getElementById('cdi-pkgc-name') || {}).value || '',
        email:   (document.getElementById('cdi-pkgc-email') || {}).value || '',
        phone:   (document.getElementById('cdi-pkgc-phone') || {}).value || '',
        state:   (document.getElementById('cdi-pkgc-state') || {}).value || '',
        notes:   (document.getElementById('cdi-pkgc-notes') || {}).value || '',
        source:  'pkg-enquiry-customise',
        submitted_at: new Date().toISOString()
      };

      if (submitBtn) submitBtn.classList.add('is-loading');
      if (errorEl)   errorEl.classList.add('is-hidden');

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok) {
            if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.disabled = true; }
            if (successEl) successEl.classList.remove('is-hidden');
            if (!self._leadSent) {
              self._leadSent = true;
              pushEvent('generate_lead', {
                form_type:      'pkg_customise',
                form_name:      'Package Enquiry – Customise',
                product_type:   'Canopy Package',
                lead_type:      'package_enquiry',
                package_handle: payload.package_handle,
                package_name:   payload.package_name,
                vehicle_model:  payload.vehicle_model || payload.vehicle_model_other,
                vehicle_year:   payload.vehicle_year,
                cab_type:       payload.cab_type,
                finish:         payload.finish,
                installation:   payload.installation,
                state:          payload.state
              });
            }
          } else {
            throw new Error('Server error ' + res.status);
          }
        })
        .catch(function () {
          self._isSubmitting = false;
          if (submitBtn) submitBtn.classList.remove('is-loading');
          if (errorEl)   errorEl.classList.remove('is-hidden');
        });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wizard.init(); });
  } else {
    wizard.init();
  }
})();

(function () {
  'use strict';

  var SPECIAL_MODELS = [
    'Ford F-150', 'Ford F-250', 'Ford F-350',
    'Chevrolet Silverado 1500', 'Chevrolet Silverado 2500',
    'Dodge RAM 1500', 'Dodge RAM 2500', 'Toyota Tundra'
  ];

  var CAB_RULES = {
    'VW Amarok':        ['Dual Cab', 'Extra Cab'],
    'Toyota LC79':      ['Dual Cab', 'Single Cab'],
    'Jeep Gladiator':   ['Dual Cab'],
    'LDV T60':          ['Dual Cab'],
    'GWM Cannon':       ['Dual Cab', 'Extra Cab'],
    'GWM Cannon Alpha': ['Dual Cab'],
    'SsangYong Musso':  ['Dual Cab'],
    'BYD Shark':        ['Dual Cab'],
    'Kia Tasman':       ['Dual Cab', 'Single Cab']
  };

  var TRAY_BY_CAB = {
    'Dual Cab':   [1650, 1850],
    'Extra Cab':  [2150],
    'Single Cab': [2450]
  };

  var DRAWER_BY_TRAY = {
    1650: [900, 1200, 1400],
    1850: [900, 1200, 1400, 1700],
    2150: [900, 1200, 1400, 1700],
    2450: [900, 1200, 1400, 1700, 2100]
  };

  var CANOPY_LENGTHS  = [1200, 1400, 1600, 1800, 2100, 2400];
  var CANOPY_3DOOR_MIN = 1600;
  var CANOPY_DOGBOX_MIN = 1400;

  var PLATFORM_OPTIONS = [1800, 2100, 2400, 2700, 3000];
  var ACC_LIMITS = { ladder: 1, tyre: 2, jerry: 2 };
  var MAX_REAR_TOTAL = 3;
  var DOOR_BLOCKS_REAR = '3 Door with rear access';
  var REAR_RACK_MIN_GAP = 400;

  var WORKER_URL = 'https://cdi-pkg-worker.coredrivenindustries.workers.dev';

  function pushEvent(eventName, params) {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish('cdi:' + eventName, params);
    }
  }

  var wizard = {
    el: null,
    steps: [],
    currentStep: 1,
    totalSteps: 6,
    isSpecial: false,
    trayLength: 0,
    canopyLength: 0,
    accCounts: { ladder: 0, tyre: 0, jerry: 0 },
    _isSubmitting: false,
    _leadSent: false,

    init: function () {
      this.el = document.getElementById('cdi-pkg-scratch');
      if (!this.el) return;
      this.steps = Array.from(this.el.querySelectorAll('.cdi-pkg-scratch__step'));

      this._bindStep1();
      this._bindStep2();
      this._bindStep3();
      this._bindStep4();
      this._bindStep5();
      this._bindStep6();
      this._bindNav();

      var panel = document.getElementById('cdi-pkg-scratch-panel');
      if (panel) {
        panel.addEventListener('cdi-pkg:flow-activated', function () {
          wizard._goToStep(1);
        });
      }
    },

    _bindStep1: function () {
      var self = this;
      var modelSel  = document.getElementById('cdi-pkgs-model');
      var yearIn    = document.getElementById('cdi-pkgs-year');
      var cabSel    = document.getElementById('cdi-pkgs-cab');
      var finishSel = document.getElementById('cdi-pkgs-finish');
      var colourIn  = document.getElementById('cdi-pkgs-colour-code');
      if (modelSel)  modelSel.addEventListener('change', function () { self._onModelChange(); });
      if (yearIn)    yearIn.addEventListener('input', function () { self._validateStep(1); });
      if (cabSel)    cabSel.addEventListener('change', function () { self._validateStep(1); });
      if (finishSel) finishSel.addEventListener('change', function () { self._onFinishChange(); });
      if (colourIn)  colourIn.addEventListener('input', function () { self._validateStep(1); });
    },

    _onModelChange: function () {
      var modelSel   = document.getElementById('cdi-pkgs-model');
      var otherField = document.getElementById('cdi-pkgs-other-model-field');
      var otherIn    = document.getElementById('cdi-pkgs-other-model');
      var specField  = document.getElementById('cdi-pkgs-spec-field');
      var specIn     = document.getElementById('cdi-pkgs-spec');
      var model      = modelSel ? modelSel.value : '';

      this.isSpecial = SPECIAL_MODELS.indexOf(model) !== -1;

      if (otherField && otherIn) {
        var showOther = model === 'Other';
        otherField.classList.toggle('is-hidden', !showOther);
        otherIn.required = showOther;
        if (!showOther) otherIn.value = '';
      }
      if (specField && specIn) {
        var showSpec = model !== '' && model !== 'Other';
        specField.classList.toggle('is-hidden', !showSpec);
        if (!showSpec) specIn.value = '';
      }

      var cabSel = document.getElementById('cdi-pkgs-cab');
      if (!cabSel) return;
      var allowed;
      if (this.isSpecial) {
        allowed = ['Dual Cab'];
      } else if (CAB_RULES[model]) {
        allowed = CAB_RULES[model];
      } else {
        allowed = ['Dual Cab', 'Extra Cab', 'Single Cab'];
      }
      cabSel.innerHTML = '<option value="">Select cab type</option>';
      allowed.forEach(function (c) { cabSel.appendChild(new Option(c, c)); });
      var cabSx = document.getElementById('cdi-pkgs-cab-selectx');
      if (cabSx && cabSx._renderOptions) { cabSx._renderOptions(); cabSx._syncValue(); }

      this._validateStep(1);
    },

    _onFinishChange: function () {
      var finishSel   = document.getElementById('cdi-pkgs-finish');
      var colourField = document.getElementById('cdi-pkgs-colour-code-field');
      var colourIn    = document.getElementById('cdi-pkgs-colour-code');
      if (!finishSel || !colourField || !colourIn) return;
      var needsCode = finishSel.value === 'Black body with colour-matched doors';
      colourField.classList.toggle('is-hidden', !needsCode);
      colourIn.required = needsCode;
      if (!needsCode) colourIn.value = '';
      this._validateStep(1);
    },

    _bindStep2: function () {
      var self = this;
      var trayLenSel = document.getElementById('cdi-pkgs-tray-length');
      var tailSel    = document.getElementById('cdi-pkgs-tail-lights');
      if (trayLenSel) trayLenSel.addEventListener('change', function () {
        self.trayLength = parseInt(trayLenSel.value) || 0;
        document.getElementById('cdi-pkgs-tray-length-val').value = trayLenSel.value;
        self._validateStep(2);
      });
      if (tailSel) tailSel.addEventListener('change', function () { self._validateStep(2); });
    },

    _setupStep2: function () {
      var cab   = (document.getElementById('cdi-pkgs-cab') || {}).value || '';
      var badge = document.getElementById('cdi-pkgs-tray-length-badge');
      var selectx = document.getElementById('cdi-pkgs-tray-length-selectx');
      var sel   = document.getElementById('cdi-pkgs-tray-length');
      var hidden = document.getElementById('cdi-pkgs-tray-length-val');

      if (this.isSpecial) {
        if (selectx) selectx.style.display = 'none';
        if (badge)   { badge.classList.remove('is-hidden'); badge.textContent = 'Custom-built (dimensions to be confirmed)'; }
        if (hidden)  hidden.value = 'Custom-built';
        if (sel)     { sel.innerHTML = '<option value="Custom-built">Custom-built</option>'; sel.value = 'Custom-built'; }
        this.trayLength = 0;
      } else {
        var lengths = TRAY_BY_CAB[cab] || [1650, 1850];
        if (selectx) selectx.style.display = '';
        if (badge)   badge.classList.add('is-hidden');

        if (lengths.length === 1) {
          if (selectx) selectx.style.display = 'none';
          if (badge)   { badge.classList.remove('is-hidden'); badge.textContent = lengths[0] + ' mm'; }
          if (sel)     { sel.innerHTML = '<option value="' + lengths[0] + '">' + lengths[0] + ' mm</option>'; sel.value = lengths[0]; }
          if (hidden)  hidden.value = lengths[0];
          this.trayLength = lengths[0];
        } else {
          if (sel) {
            sel.innerHTML = '<option value="">Select length</option>';
            lengths.forEach(function (l) { sel.appendChild(new Option(l + ' mm', l)); });
            sel.value = '';
          }
          if (hidden) hidden.value = '';
          this.trayLength = 0;
          var sx = document.getElementById('cdi-pkgs-tray-length-selectx');
          if (sx && sx._renderOptions) { sx._renderOptions(); sx._syncValue(); }
        }
      }

      var tailSel = document.getElementById('cdi-pkgs-tail-lights');
      if (tailSel) tailSel.value = '';
      var tailSx = document.getElementById('cdi-pkgs-tail-lights-selectx');
      if (tailSx && tailSx._syncValue) tailSx._syncValue();

      this._validateStep(2);
    },

    _bindStep3: function () {
      var self = this;
      var canopyLenSel = document.getElementById('cdi-pkgs-canopy-length');
      var doorSel      = document.getElementById('cdi-pkgs-canopy-doors');
      if (canopyLenSel) canopyLenSel.addEventListener('change', function () {
        self.canopyLength = parseInt(canopyLenSel.value) || 0;
        self._updateDoorOptions();
        self._validateStep(3);
      });
      if (doorSel) doorSel.addEventListener('change', function () { self._validateStep(3); });
    },

    _setupStep3: function () {
      var notice       = document.getElementById('cdi-pkgs-custom-canopy-notice');
      var lenField     = document.getElementById('cdi-pkgs-canopy-length-field');
      var canopyLenSel = document.getElementById('cdi-pkgs-canopy-length');

      if (this.isSpecial) {
        if (notice) notice.classList.remove('is-hidden');
        if (lenField) lenField.classList.add('is-hidden');
        if (canopyLenSel) {
          canopyLenSel.innerHTML = '<option value="Custom-built">Custom-built</option>';
          canopyLenSel.value = 'Custom-built';
          canopyLenSel.required = false;
          var sxLen = document.getElementById('cdi-pkgs-canopy-length-selectx');
          if (sxLen && sxLen._renderOptions) { sxLen._renderOptions(); sxLen._syncValue(); }
        }
        this.canopyLength = 0;
        this._updateDoorOptions();
      } else {
        if (notice) notice.classList.add('is-hidden');
        if (lenField) lenField.classList.remove('is-hidden');
        if (canopyLenSel) {
          var tray = this.trayLength;
          var current = canopyLenSel.value;
          canopyLenSel.innerHTML = '<option value="">Select length</option>';
          CANOPY_LENGTHS.forEach(function (l) {
            if (tray === 0 || l <= tray) {
              canopyLenSel.appendChild(new Option(l + ' mm', l));
            }
          });
          canopyLenSel.required = true;
          if (canopyLenSel.querySelector('option[value="' + current + '"]')) {
            canopyLenSel.value = current;
            this.canopyLength = parseInt(current) || 0;
          } else {
            canopyLenSel.value = '';
            this.canopyLength = 0;
          }
          var sx = document.getElementById('cdi-pkgs-canopy-length-selectx');
          if (sx && sx._renderOptions) { sx._renderOptions(); sx._syncValue(); }
        }
        this._updateDoorOptions();
      }
      this._validateStep(3);
    },

    _updateDoorOptions: function () {
      var doorSel = document.getElementById('cdi-pkgs-canopy-doors');
      if (!doorSel) return;
      var canopy = this.isSpecial ? Infinity : this.canopyLength;
      var current = doorSel.value;
      doorSel.innerHTML = '<option value="">Select doors</option>';
      doorSel.appendChild(new Option('2 Door', '2 Door'));
      if (canopy >= CANOPY_3DOOR_MIN) {
        doorSel.appendChild(new Option('3 Door with rear access', '3 Door with rear access'));
      }
      if (canopy >= CANOPY_DOGBOX_MIN) {
        doorSel.appendChild(new Option('3 Door including half dog box', '3 Door including half dog box'));
        doorSel.appendChild(new Option('4 Door including full dog box', '4 Door including full dog box'));
      }
      if (doorSel.querySelector('option[value="' + current + '"]')) {
        doorSel.value = current;
      } else {
        doorSel.value = '';
      }
      var sx = document.getElementById('cdi-pkgs-canopy-doors-selectx');
      if (sx && sx._renderOptions) { sx._renderOptions(); sx._syncValue(); }
    },

    _bindStep4: function () {
      var self = this;
      this.el.querySelectorAll('.cdi-pkg-scratch__stepper-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self._stepAcc(btn.dataset.acc, parseInt(btn.dataset.dir));
        });
      });
    },

    _setupStep4: function () {
      this._updateDrawerOptions();
      this._updateRearRackVisibility();
      var door    = (document.getElementById('cdi-pkgs-canopy-doors') || {}).value || '';
      var notice  = document.getElementById('cdi-pkgs-rear-acc-notice');
      var blocked = door === DOOR_BLOCKS_REAR;
      if (notice) notice.classList.toggle('is-hidden', !blocked);
      this.accCounts = { ladder: 0, tyre: 0, jerry: 0 };
      this._syncAccDisplay();
    },

    _updateDrawerOptions: function () {
      var drawerSel = document.getElementById('cdi-pkgs-drawer');
      if (!drawerSel) return;
      var tray    = this.trayLength;
      var options = tray ? (DRAWER_BY_TRAY[tray] || []) : [900, 1200, 1400, 1700];
      var current = drawerSel.value;
      drawerSel.innerHTML = '<option value="None">No trundle drawer</option>';
      options.forEach(function (d) { drawerSel.appendChild(new Option(d + ' mm', d)); });
      if (drawerSel.querySelector('option[value="' + current + '"]')) {
        drawerSel.value = current;
      } else {
        drawerSel.value = 'None';
      }
      var sx = document.getElementById('cdi-pkgs-drawer-selectx');
      if (sx && sx._renderOptions) { sx._renderOptions(); sx._syncValue(); }
    },

    _updateRearRackVisibility: function () {
      var field    = document.getElementById('cdi-pkgs-rear-rack-field');
      var hint     = document.getElementById('cdi-pkgs-rear-rack-hint');
      var yesRadio = document.getElementById('cdi-pkgs-rear-rack-yes');
      var noRadio  = document.getElementById('cdi-pkgs-rear-rack-no');
      if (!field) return;

      var gap = (this.trayLength && this.canopyLength)
        ? this.trayLength - this.canopyLength
        : -1;

      var available = this.isSpecial || gap < 0 || gap >= REAR_RACK_MIN_GAP;

      field.style.display = '';

      if (available) {
        if (yesRadio) { yesRadio.disabled = false; }
        if (hint) { hint.textContent = ''; hint.classList.add('is-hidden'); }
      } else {
        if (yesRadio) { yesRadio.disabled = true; yesRadio.checked = false; }
        if (noRadio)  { noRadio.checked = true; }
        if (hint) {
          hint.textContent = 'Not available — insufficient space between tray and canopy.';
          hint.classList.remove('is-hidden');
        }
      }
    },

    _stepAcc: function (acc, dir) {
      var current = this.accCounts[acc] || 0;
      var limit   = ACC_LIMITS[acc] || 1;
      var total   = this.accCounts.ladder + this.accCounts.tyre + this.accCounts.jerry;
      var newVal  = current + dir;
      if (newVal < 0 || newVal > limit) return;
      if (dir > 0 && total >= MAX_REAR_TOTAL) return;
      this.accCounts[acc] = newVal;
      var el = this.el.querySelector('.cdi-pkg-scratch__stepper-val[data-acc="' + acc + '"]');
      if (el) el.textContent = newVal;
      var hiddenMap = { ladder: 'cdi-pkgs-acc-ladder', tyre: 'cdi-pkgs-acc-tyre', jerry: 'cdi-pkgs-acc-jerry' };
      var h = document.getElementById(hiddenMap[acc]);
      if (h) h.value = newVal;
      this._refreshStepperButtons();
    },

    _syncAccDisplay: function () {
      var self = this;
      ['ladder', 'tyre', 'jerry'].forEach(function (acc) {
        var el = self.el.querySelector('.cdi-pkg-scratch__stepper-val[data-acc="' + acc + '"]');
        if (el) el.textContent = 0;
        var hiddenMap = { ladder: 'cdi-pkgs-acc-ladder', tyre: 'cdi-pkgs-acc-tyre', jerry: 'cdi-pkgs-acc-jerry' };
        var h = document.getElementById(hiddenMap[acc]);
        if (h) h.value = 0;
      });
      this._refreshStepperButtons();
    },

    _refreshStepperButtons: function () {
      var self  = this;
      var total = this.accCounts.ladder + this.accCounts.tyre + this.accCounts.jerry;
      ['ladder', 'tyre', 'jerry'].forEach(function (acc) {
        var current = self.accCounts[acc];
        var limit   = ACC_LIMITS[acc];
        var plus  = self.el.querySelector('.cdi-pkg-scratch__stepper-btn[data-acc="' + acc + '"][data-dir="1"]');
        var minus = self.el.querySelector('.cdi-pkg-scratch__stepper-btn[data-acc="' + acc + '"][data-dir="-1"]');
        if (plus)  plus.disabled  = current >= limit || total >= MAX_REAR_TOTAL;
        if (minus) minus.disabled = current <= 0;
      });
    },

    _bindStep5: function () {
      var self    = this;
      var radios  = this.el.querySelectorAll('input[name="s_installation"]');
      var listField = document.getElementById('cdi-pkgs-install-checklist-field');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (listField) listField.classList.toggle('is-hidden', r.value !== 'Yes');
          self._validateStep(5);
        });
      });
    },

    _bindStep6: function () {
      var self    = this;
      var nameIn  = document.getElementById('cdi-pkgs-name');
      var emailIn = document.getElementById('cdi-pkgs-email');
      if (nameIn)  nameIn.addEventListener('input', function () { self._validateStep(6); });
      if (emailIn) emailIn.addEventListener('input', function () { self._validateStep(6); });
      var submitBtn = document.getElementById('cdi-pkgs-submit-btn');
      if (submitBtn) {
        submitBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self._submitForm();
        });
      }
    },

    _validateStep: function (n) {
      var self = this;

      if (n === 1) {
        var nextBtn = self.el.querySelector('.cdi-pkg-scratch__step[data-step="1"] .cdi-pkg-scratch__btn--next');
        var model  = (document.getElementById('cdi-pkgs-model') || {}).value || '';
        var year   = ((document.getElementById('cdi-pkgs-year') || {}).value || '').trim();
        var cab    = (document.getElementById('cdi-pkgs-cab') || {}).value || '';
        var finish = (document.getElementById('cdi-pkgs-finish') || {}).value || '';
        var colour = ((document.getElementById('cdi-pkgs-colour-code') || {}).value || '').trim();
        var other  = ((document.getElementById('cdi-pkgs-other-model') || {}).value || '').trim();
        var valid  = model && year.length >= 4 && cab && finish;
        if (finish === 'Black body with colour-matched doors' && !colour) valid = false;
        if (model === 'Other' && !other) valid = false;
        if (nextBtn) nextBtn.disabled = !valid;

      } else if (n === 2) {
        var nextBtn2 = self.el.querySelector('.cdi-pkg-scratch__step[data-step="2"] .cdi-pkg-scratch__btn--next');
        var trayLen = (document.getElementById('cdi-pkgs-tray-length-val') || {}).value || '';
        var tail    = (document.getElementById('cdi-pkgs-tail-lights') || {}).value || '';
        var valid2  = (trayLen || self.isSpecial) && tail;
        if (nextBtn2) nextBtn2.disabled = !valid2;

      } else if (n === 3) {
        var nextBtn3 = self.el.querySelector('.cdi-pkg-scratch__step[data-step="3"] .cdi-pkg-scratch__btn--next');
        var door3 = (document.getElementById('cdi-pkgs-canopy-doors') || {}).value || '';
        if (self.isSpecial) {
          if (nextBtn3) nextBtn3.disabled = !door3;
        } else {
          var canopyLen = (document.getElementById('cdi-pkgs-canopy-length') || {}).value || '';
          if (nextBtn3) nextBtn3.disabled = !(canopyLen && door3);
        }

      } else if (n === 5) {
        var nextBtn5 = self.el.querySelector('.cdi-pkg-scratch__step[data-step="5"] .cdi-pkg-scratch__btn--next');
        var install  = self.el.querySelector('input[name="s_installation"]:checked');
        if (nextBtn5) nextBtn5.disabled = !install;

      } else if (n === 6) {
        var submitBtn = document.getElementById('cdi-pkgs-submit-btn');
        var name  = ((document.getElementById('cdi-pkgs-name') || {}).value || '').trim();
        var email = ((document.getElementById('cdi-pkgs-email') || {}).value || '').trim();
        var ok    = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (submitBtn) submitBtn.disabled = !(name && ok);
      }
    },

    _bindNav: function () {
      var self = this;
      this.el.querySelectorAll('.cdi-pkg-scratch__btn--next').forEach(function (btn) {
        btn.addEventListener('click', function () { self._goToStep(parseInt(btn.dataset.next)); });
      });
      this.el.querySelectorAll('.cdi-pkg-scratch__btn--back').forEach(function (btn) {
        btn.addEventListener('click', function () { self._goToStep(parseInt(btn.dataset.back)); });
      });
    },

    _goToStep: function (n) {
      if (n < 1 || n > this.totalSteps) return;
      this.steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i + 1 === n);
      });
      var STEP_NAMES = ['Vehicle', 'Tray', 'Canopy', 'Add-ons', 'Installation', 'Your info'];
      var fillPct = ((n - 1) / (this.totalSteps - 1) * 100).toFixed(1);
      var countEl = document.getElementById('cdi-pkgs-progress-count');
      var nameEl  = document.getElementById('cdi-pkgs-progress-name');
      var fillEl  = document.getElementById('cdi-pkgs-progress-fill');
      var trackEl = fillEl && fillEl.closest('[role="progressbar"]');
      if (countEl) countEl.textContent = 'Step ' + n + ' of ' + this.totalSteps;
      if (nameEl)  nameEl.textContent  = STEP_NAMES[n - 1] || '';
      if (fillEl)  fillEl.style.width  = fillPct + '%';
      if (trackEl) trackEl.setAttribute('aria-valuenow', n);
      this.currentStep = n;

      if (n === 2) this._setupStep2();
      if (n === 3) this._setupStep3();
      if (n === 4) this._setupStep4();
      if (n === 6) this._validateStep(6);

      var progressBar = this.el.querySelector('.cdi-pkg-scratch__progress');
      if (progressBar) progressBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var newStep = this.el.querySelector('.cdi-pkg-scratch__step[data-step="' + n + '"]');
      if (newStep) {
        var title = newStep.querySelector('.cdi-pkg-scratch__step-title');
        if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
      }
    },

    _submitForm: function () {
      var phoneEl = document.getElementById('cdi-pkgs-phone');
      if (phoneEl && !phoneEl.value.trim()) {
        phoneEl.focus();
        phoneEl.reportValidity();
        return;
      }
      if (this._isSubmitting) return;
      this._isSubmitting = true;

      var self      = this;
      var submitBtn = document.getElementById('cdi-pkgs-submit-btn');
      var successEl = document.getElementById('cdi-pkgs-feedback-success');
      var errorEl   = document.getElementById('cdi-pkgs-feedback-error');

      var installChecks = Array.from(
        this.el.querySelectorAll('input[name="s_install_includes[]"]:checked')
      ).map(function (cb) { return cb.value; });

      var roofRack = (document.getElementById('cdi-pkgs-roof-rack') || {}).value || 'None';
      var roofRackBars     = null;
      var roofRackPlatform = null;
      if (roofRack === '2 bars') { roofRackBars = 2; }
      else if (roofRack === '3 bars') { roofRackBars = 3; }
      else if (roofRack.indexOf('Platform') === 0) {
        roofRackPlatform = roofRack.replace('Platform ', '');
      }

      var rearRackRadio = this.el.querySelector('input[name="rear_rack"]:checked');
      var rearRack = rearRackRadio ? rearRackRadio.value === 'true' : false;

      var trayLenVal = (document.getElementById('cdi-pkgs-tray-length-val') || {}).value || '';

      var payload = {
        enquiry_type:    'scratch',
        vehicle_model:   (document.getElementById('cdi-pkgs-model') || {}).value || '',
        vehicle_model_other: (document.getElementById('cdi-pkgs-other-model') || {}).value || '',
        vehicle_spec:    (document.getElementById('cdi-pkgs-spec') || {}).value || '',
        vehicle_year:    (document.getElementById('cdi-pkgs-year') || {}).value || '',
        cab_type:        (document.getElementById('cdi-pkgs-cab') || {}).value || '',
        finish:          (document.getElementById('cdi-pkgs-finish') || {}).value || '',
        colour_code:     (document.getElementById('cdi-pkgs-colour-code') || {}).value || '',
        tray_length:     trayLenVal,
        tray_tail_lights:(document.getElementById('cdi-pkgs-tail-lights') || {}).value || '',
        tray_drop_sides: (document.getElementById('cdi-pkgs-drop-sides') || {}).value || 'None',
        canopy_length:   this.isSpecial ? 'Custom-built' : ((document.getElementById('cdi-pkgs-canopy-length') || {}).value || ''),
        canopy_doors:    this.isSpecial ? 'Custom-built' : ((document.getElementById('cdi-pkgs-canopy-doors') || {}).value || ''),
        trundle_drawer:  (document.getElementById('cdi-pkgs-drawer') || {}).value || 'None',
        roof_rack_bars:       roofRackBars,
        roof_rack_platform:   roofRackPlatform,
        rear_rack:       rearRack,
        acc_ladder:      this.accCounts.ladder,
        acc_tyre:        this.accCounts.tyre,
        acc_jerry:       this.accCounts.jerry,
        installation:    ((this.el.querySelector('input[name="s_installation"]:checked') || {}).value) || '',
        install_includes: installChecks,
        name:    (document.getElementById('cdi-pkgs-name') || {}).value || '',
        email:   (document.getElementById('cdi-pkgs-email') || {}).value || '',
        phone:   (document.getElementById('cdi-pkgs-phone') || {}).value || '',
        state:   (document.getElementById('cdi-pkgs-state') || {}).value || '',
        notes:   (document.getElementById('cdi-pkgs-notes') || {}).value || '',
        source:  'pkg-enquiry-scratch',
        submitted_at: new Date().toISOString()
      };

      if (submitBtn) submitBtn.classList.add('is-loading');
      if (errorEl)   errorEl.classList.add('is-hidden');

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok) {
            if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.disabled = true; }
            if (successEl) successEl.classList.remove('is-hidden');
            if (!self._leadSent) {
              self._leadSent = true;
              pushEvent('generate_lead', {
                form_type:     'pkg_scratch',
                form_name:     'Package Enquiry – Scratch',
                product_type:  'Canopy Package',
                lead_type:     'package_enquiry',
                vehicle_model: payload.vehicle_model || payload.vehicle_model_other,
                vehicle_year:  payload.vehicle_year,
                cab_type:      payload.cab_type,
                finish:        payload.finish,
                tray_length:   payload.tray_length,
                canopy_length: payload.canopy_length,
                installation:  payload.installation,
                state:         payload.state
              });
            }
          } else {
            throw new Error('Server error ' + res.status);
          }
        })
        .catch(function () {
          self._isSubmitting = false;
          if (submitBtn) submitBtn.classList.remove('is-loading');
          if (errorEl)   errorEl.classList.remove('is-hidden');
        });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wizard.init(); });
  } else {
    wizard.init();
  }
})();

(function () {
  'use strict';

  function initFlowSelector() {
    var section = document.getElementById('cdi-pkg-enquiry');
    if (!section) return;

    var cards = section.querySelectorAll('.cdi-pkg-enquiry__flow-card');

    var urlParams = new URLSearchParams(window.location.search);
    var flowParam = urlParams.get('flow');
    if (flowParam === 'customise' || flowParam === 'scratch') {
      activateFlow(flowParam, true);
      return;
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        activateFlow(card.dataset.flow, false);
      });
    });

    var productHandle = urlParams.get('product') || '';
    var packageCode = productHandle.replace('-package-', '-');
    if (productHandle && packageCode !== productHandle) {
      resolveVariantFinish(productHandle, urlParams.get('variant')).then(function (finish) {
        activateFlow('customise', true, { package: packageCode, finish: finish });
      });
    }
  }

  function resolveVariantFinish(handle, variantId) {
    if (!variantId) return Promise.resolve('');
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        var variants = (product && product.variants) || [];
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) return variants[i].option1 || '';
        }
        return '';
      })
      .catch(function () { return ''; });
  }

  function activateFlow(flow, skipScroll, extraParams) {
    var panels = document.querySelectorAll('[data-flow-panel]');

    document.querySelectorAll('.cdi-pkg-enquiry__flow-card').forEach(function (c) {
      c.classList.toggle('is-selected', c.dataset.flow === flow);
    });

    panels.forEach(function (panel) {
      var isTarget = panel.dataset.flowPanel === flow;
      panel.classList.toggle('is-hidden', !isTarget);
    });

    var activePanel = document.querySelector('[data-flow-panel="' + flow + '"]');
    if (activePanel) {
      activePanel.dispatchEvent(new CustomEvent('cdi-pkg:flow-activated', {
        bubbles: false,
        detail: { params: Object.assign(Object.fromEntries(new URLSearchParams(window.location.search)), extraParams || {}) }
      }));
    }

    if (!skipScroll) {
      var progressEl = activePanel && activePanel.querySelector('.cdi-pkg-cust__progress, .cdi-pkg-scratch__progress');
      var scrollTarget = progressEl || activePanel || document.getElementById('cdi-pkg-enquiry');
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('cdi-pkg:switch-to-scratch', function () {
    activateFlow('scratch', false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlowSelector);
  } else {
    initFlowSelector();
  }
})();
